import { render, staticRenderFns } from "./WishListCount.vue?vue&type=template&id=f216da8a&"
import script from "./WishListCount.vue?vue&type=script&lang=js&"
export * from "./WishListCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\SchuckerP\\git\\plenty-plugins\\4024\\15\\modeherz\\plugin-ceres\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f216da8a')) {
      api.createRecord('f216da8a', component.options)
    } else {
      api.reload('f216da8a', component.options)
    }
    module.hot.accept("./WishListCount.vue?vue&type=template&id=f216da8a&", function () {
      api.rerender('f216da8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/modeherz/components/wishlist/WishListCount.vue"
export default component.exports